export default "__VITE_ASSET__DHo3z$QW__"